import { ObservableArray, View } from "binder"
import { PropertiesPanelViewModel, propertyWrapper } from "./propertiesPanel-viewModel"

export class PropertiesPanelView extends View<PropertiesPanelViewModel>{
    GetViewUniqueId(): string {
        return "V-29D43C68-D99C-402A-BA71-14271B37E1CC"
    }
    loadHtml(): string {
        let element = require('./propertiesPanel.html').default;
        let style = require('./propertiesPanel.less');
        return element;
    }
    constructor() {
       super();
    }

    public set properties(v: ObservableArray<propertyWrapper>) { this._properties = v; } public get properties(): ObservableArray<propertyWrapper> { return this._properties;} private _properties: ObservableArray<propertyWrapper>;

    AddNewProperty(){
        this.dataContext.AddNewProperty();
    }
}
